import { isNumber } from '@utopia-utils/core'

import { fenToYuan } from './fenToYuan'

type Options = {
  /**
   * 单位，分或元
   * @default 'fen'
   */
  unit?: 'fen' | 'yun'
}

/**
 * 金额格式化(单位默认是 分), 分转元(如果单位是分)，并保留两位小数，最后添加千位分隔符
 * @param num 金额
 * @param options
 * @returns 格式化后的金额, 如果输入不是数字，则返回 '-'
 */
export function yunFormat(num?: number, options?: Options): string | '-' {
  try {
    if (!isNumber(num) || Number.isNaN(num))
      return '-'

    const { unit = 'fen' } = options ?? {}

    const yun = unit === 'fen' ? fenToYuan(num) : num

    if (yun === null)
      return '-'

    return yun.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  catch (err) {
    console.error(err)
    return '-'
  }
}
